module.exports = __webpack_public_path__ + "svg/leo.svg?b05b989e962ac6fedce8cea76b4b1fe5";